module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 79.23076923076923,
						"dataLabels": {
							"enabled": true,
							"format": "103",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.15384615384615,
						"dataLabels": {
							"enabled": true,
							"format": "86",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": true,
							"format": "78",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.07692307692308,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 41.53846153846154,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.94915254237289,
						"dataLabels": {
							"enabled": true,
							"format": "286",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.16949152542372,
						"dataLabels": {
							"enabled": true,
							"format": "266",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.06779661016948,
						"dataLabels": {
							"enabled": true,
							"format": "248",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.5593220338983,
						"dataLabels": {
							"enabled": true,
							"format": "217",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.389830508474574,
						"dataLabels": {
							"enabled": true,
							"format": "187",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.27891156462584,
						"dataLabels": {
							"enabled": true,
							"format": "572",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.6938775510204,
						"dataLabels": {
							"enabled": true,
							"format": "498",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.29251700680273,
						"dataLabels": {
							"enabled": true,
							"format": "478",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.29931972789116,
						"dataLabels": {
							"enabled": true,
							"format": "431",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.693877551020414,
						"dataLabels": {
							"enabled": true,
							"format": "351",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.50623441396509,
						"dataLabels": {
							"enabled": true,
							"format": "1173",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.36242726517041,
						"dataLabels": {
							"enabled": true,
							"format": "1063",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.70490440565254,
						"dataLabels": {
							"enabled": true,
							"format": "1019",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.63175394846218,
						"dataLabels": {
							"enabled": true,
							"format": "970",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.74231088944306,
						"dataLabels": {
							"enabled": true,
							"format": "839",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -20.769230769230774,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.504854368932044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.302325581395355,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.538461538461542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.050847457627115,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.99300699300699,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.766917293233088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.824884792626724,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.7210884353741527,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.937062937062937,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.016064257028118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.832635983263593,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.561484918793504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.493765586034913,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.377664109121909,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.139228598306676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.80863591756624,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.505154639175254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=130"
			},
			{
				"x": 9,
				"text": "30–39<br>n=295"
			},
			{
				"x": 15,
				"text": "40–49<br>n=588"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1203"
			}
		],
		"dataTable": {
			"< 30": [
				130,
				103,
				86,
				78,
				69,
				54
			],
			"30–39": [
				295,
				286,
				266,
				248,
				217,
				187
			],
			"40–49": [
				588,
				572,
				498,
				478,
				431,
				351
			],
			"≥ 50": [
				1203,
				1173,
				1063,
				1019,
				970,
				839
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 199
// module chunks = 0